export class ApplicationNames {
	public static readonly PORTFOLIO_ANALYSER: string = 'portfolio-analyser';
	public static readonly SCENARIO_TESTER: string = 'scenario-tester';
	public static readonly TAX_ESTIMATOR: string = 'tax-estimator';
	public static readonly DASHBOARD: string = 'dashboard';
	public static readonly MY_SAVED_PORTFOLIOS: string = 'my-portfolios';
	public static readonly PORTFOLIO_ANALYSIS_CONSTRUCTION: string = 'portfolio-analysis-construction';
	public static readonly PORTFOLIO_CENTRE: string = 'portfolio-centre';
	public static readonly PORTFOLIO_CENTRE_360: string = 'portfolio-centre-360';
	public static readonly MODELS_BROWSE: string = 'models-browse';
	public static readonly CMA_ESTIMATOR: string = 'cma-estimator';
	public static readonly SECURE_DASHBOARD: string = 'secure-dashboard';
	public static readonly INVESTMENT_QUALITY: string = 'investment-quality';
	public static readonly IRETIRE_ACCUM: string = 'iretire-accum';
	public static readonly IRETIRE_DECUM: string = 'iretire-decum';
	public static readonly PROFESSIONAL_INVESTORS: string = 'professional-investors';
	public static readonly MODELS_EXPERIENCE: string = 'models-experience';
	public static readonly AC_PORTFOLIO_LIBRARY: string = 'ac-portfolio-library';
}

export class SharedApplicationConstants {
	public static readonly MODEL_FAMILY = {
		BLACKROCK_FAMILY_GROUP: 'blackrock_family_group',
		BLACKROCK_FAMILY_GROUP_TITLE: 'BlackRock Models'
	};
	public static readonly MODEL_FAMILY_AU = {
		BLACKROCK_FAMILY_GROUP: 'blackrock_au_family_group',
		BLACKROCK_FAMILY_GROUP_TITLE: 'BlackRock Models'
	};
	// Other
	public static readonly REBALANCE_GLITCH: string = 'REBALANCE_GLITCH';
	public static readonly OUTPUT_DESIGNATION = 'outputDesignation';
	public static readonly PORTFOLIO_TYPE_MODEL = 'model';
	public static readonly DEFAULT_REQUEST_TIMEOUT = 60 * 1000;
	public static readonly REPORT_GENERATION_REQUEST_TIMEOUT = 3 * 60 * 1000;
	public static readonly PORTFOLIO_WEIGHT_ID = 'portfolioWeight';
	public static readonly PORTFOLIO_SCENARIO_ID = 'portfolioScenario';
	public static readonly BENCHMARK_WEIGHT_ID = 'benchmarkWeight';
	public static readonly PORTFOLIO_ANALYSER_PAGE = 'portfolioAnalyserPage';
	public static readonly DIALOG_TABLE_MODE = {
		COMPARE: 'COMPARE',
		REPLACE: 'REPLACE'
	};
	public static readonly MANAGEMENT_TYPE_MANAGED = 'managed';
	public static readonly PC_APPS = [ApplicationNames.PORTFOLIO_CENTRE, ApplicationNames.PORTFOLIO_CENTRE_360];

	public static readonly IMAGE_REMOTE_PATH = '/images/tools-assets/';
}

// update this when moving applications to hybrid/ wwe mode
export class ApplicationApiConfig {
	public static readonly WDS_APPS = [
		ApplicationNames.PORTFOLIO_ANALYSER,
		ApplicationNames.SCENARIO_TESTER,
		ApplicationNames.TAX_ESTIMATOR,
		ApplicationNames.DASHBOARD,
		ApplicationNames.MY_SAVED_PORTFOLIOS,
		ApplicationNames.MODELS_BROWSE,
		ApplicationNames.CMA_ESTIMATOR
	];
	public static readonly WWE_APPS = [
		ApplicationNames.PORTFOLIO_ANALYSIS_CONSTRUCTION,
		ApplicationNames.PORTFOLIO_CENTRE,
		ApplicationNames.PORTFOLIO_CENTRE_360,
		ApplicationNames.CMA_ESTIMATOR,
		ApplicationNames.PORTFOLIO_ANALYSER
	];
}

export class ApplicationEntryPoints {
	public static readonly PORTFOLIO_CENTRE_DASHBOARD: string = 'DASHBOARD';
	public static readonly PORTFOLIO_CENTRE_360: string = 'PORTFOLIO360';
}

export class ApplicationMaxPortfolios {
	public static readonly TAX_ESTIMATOR: number = 1;
	public static readonly SCENARIO_TESTER: number = 50;
	public static readonly CMA_ESTIMATOR: number = 1;
	public static readonly PORTFOLIO_CENTRE: number = 4;
	public static readonly PORTFOLIO_ANALYSER: number = 3;
}

export enum DialogIcon {
	EXCLAMATION_TRIANGLE = 'Alert_warning.svg',
	CHECK_MARK = 'Confirmation_check.svg',
	ALERT_MARK = 'Caution_alert.svg'
}

export enum GridClass {
	GRID_980 = 'grid-980',
	GRID_1440 = 'grid-1440',
	GRID_1920 = 'grid-1920',
	DAISY = 'dz-grid'
}
